import React from 'react';
import classNames from 'classnames';

import css from './ManageListingCard.module.css';

/**
 * Menu icon
 *
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {boolean} [props.isActive] - Whether the menu is active
 * @returns {JSX.Element} Menu icon components
 */
const MenuIcon = props => {
  const { className, isActive = false } = props;
  const classes = classNames(css.menuIcon, className);
  const filter = isActive ? '' : 'url(#a)';
  return (
    <svg
      className={classes}
      width="18"
      height="12"
      viewBox="0 0 18 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fillRule="evenodd">
        <rect width="18" height="2" rx="1" />
        <rect y="5" width="18" height="2" rx="1" />
        <rect y="10" width="18" height="2" rx="1" />
      </g>
    </svg>
  );
};

export default MenuIcon;
